<!-- @format -->

<company-info-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">入力内容の確認</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">
            <a onclick="{ props.onFirst }">会社情報</a>
          </li>
          <li class="breadcrumb-item">
            <a onclick="{ props.onForm }">登録情報変更手続き</a>
          </li>
          <li class="breadcrumb-item">入力内容の確認</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="lead_block">
        <p>
          以下の内容で法人申請を行います。
          <br />
          入力いただいた内容に誤りがないかご確認の上、「上記内容で申請」ボタンをクリックしてください。
        </p>
      </div>
      <!--/.lead_block-->

      <div class="contents_block">
        <form class="application_form">
          <company-detail
            before="{ props.before }"
            data="{ props.params }"
            prefs="{ props.prefs }"
          ></company-detail>

          <div class="checkbox_wrap">
            <input
              type="checkbox"
              name="privacy"
              id="privacy"
              class="checkbox-input js-check"
              onclick="{ onCheck }"
            />
            <label for="privacy" class="checkbox-parts">
              <a
                target="_blank"
                href="https://cro-co.co.jp/privacypolicy/agreement/"
              >
                CROCO株式会社の個人情報の取り扱い
              </a>
              に同意する
            </label>
          </div>

          <div class="container_button">
            <button
              class="button button-clear"
              type="button"
              value="戻る"
              data-target=""
              onclick="{ props.onForm }"
            >
              戻る
            </button>
            <button
              name="submit"
              class="button button-primary button_checked"
              type="button"
              value="確認画面へ"
              data-target=""
              onclick="{ submit }"
              disabled
            >
              確認画面へ
            </button>
          </div>
          <!--/.container_button-->
        </form>
        <!--/.application_form-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import routes from "@model/menu-routes.js";
    import detail from "@tags/parts/company-detail.riot";
    import complete from "./company-info-complete.riot";

    export default {
      components: {
        "company-info-complete": complete,
        "company-detail": detail,
      },
      state: {
        privacy: false,
        errorMessage: false,
        isComplete: false,
      },
      onBeforeMount(props, state) {
        this.routes = routes;
      },
      onCheck(e) {
        this.state.privacy = e.target.checked;
        this.$('button[name="submit"]').disabled = !this.state.privacy;
      },
      submit(e) {
        if (!this.state.privacy) {
          di.toast.push("規約に同意して下さい。", "negative");
          this.update({ errorMessage: "規約に同意して下さい" });
          return;
        }
        this.props.onSubmit();
      },
    };
  </script>
</company-info-tag>
